import { useAppSelector } from '../../../Hooks/useAppSelector'
import { ConsigneeSelectors } from '../StoreAdapter'

export const useConsigneesSelector = () => {
  return useAppSelector(ConsigneeSelectors.selectEntities)
}
